import { render, staticRenderFns } from "./DialogEmployeeWithItems.vue?vue&type=template&id=371f545d"
import script from "./DialogEmployeeWithItems.vue?vue&type=script&lang=js"
export * from "./DialogEmployeeWithItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports